import { UploadConditionReportFields } from '../helpers';
import { useGetRequiredRule } from '@/hooks';
import { useTranslation } from 'react-i18next';

export const useGetUploadReportRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });

  return {
    [UploadConditionReportFields.CONDITION_REPORT_CREATED_AT]: [requiredRule],
    [UploadConditionReportFields.PRICE]: [requiredRule],
    [UploadConditionReportFields.RATE_REPORT_CREATED_AT]: [requiredRule],
  };
};
